import React from 'react'
import { AboutPagePicture } from './AboutPage.Styled'

const AboutPage = () => {
  return (
    <AboutPagePicture>
      <div className="body-header">
        <div className="data">
          <div className="text">
            <b>Meet Your</b>
            <br />
            Social Curator /<br />
            Secret Weapon
          </div>
          <h1 className="meet">meet</h1>
        </div>
        <div className="picture">
          <div className="image" />
          <div className="spacer" />
        </div>
      </div>

      <div className="content-data">
        <div className="content">
          <h2>
            Hey, boo! Jasmine Star here—your social strategist, photographer, stylist, planner, and
            copywriter.
          </h2>

          <div style={{ height: '600px', background: 'yellow' }}>gg</div>
        </div>
      </div>
    </AboutPagePicture>
  )
}

export default AboutPage
